<template>
  <div>
    <ContractForm
      :contract="contract"
      @clear="clearForm"
    />
    <ForeignerText
      :contract="contract"
      :company="company"
      :companyObject="companyObject"
    />
  </div>
</template>

<script>
import viewsMixin from '@/mixins/views-mixin';
import ContractForm from '@/components/ContractForm.vue';
import ForeignerText from '@/components/ForeignerText.vue';

export default {
  name: 'Artist',
  components: {
    ContractForm,
    ForeignerText,
  },
  mixins: [viewsMixin],
};
</script>
